export const ShippingAndBillingLandingPageTemplate = {
    slots: ['SlbCheckoutContainerSlot'],
};